// assets/video-popup.js

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('[data-video-popup] .product-video-popup__trigger');
    const header = document.querySelector('.shopify-section-group-header-group');
    const nav = document.querySelector('.lux-header');

    if (!triggers.length) return;

    triggers.forEach(trigger => {
      trigger.addEventListener('click', function () {
        const popupWrapper = trigger.closest('[data-video-popup]');
        console.log("POPUP WRAPPER: ", popupWrapper)
        if (!popupWrapper) return;

        document.body.classList.add('lux-overlay-triggered')
        header.classList.remove = 5;
        nav.style.zIndex = 5;
        const overlay = popupWrapper.querySelector('[data-popup-overlay]');
        console.log("overlay: ", overlay)
        if (!overlay) return;

        overlay.classList.remove('hidden');
      });
    });

    const closeButtons = document.querySelectorAll('[data-popup-close]');

    closeButtons.forEach(button => {
      button.addEventListener('click', function () {
        const overlay = button.closest('[data-popup-overlay]');
        if (!overlay) return;
        document.body.classList.remove('lux-overlay-triggered')
        header.style.zIndex = 100;
        nav.style.zIndex = 100;
        overlay.classList.add('hidden');

        const video = overlay.querySelector('video');
        if (video) video.pause();
      });
    });
  });
})();
